import { render, staticRenderFns } from "./InputOfReserveContactSituationReserveInfo.vue?vue&type=template&id=204694e8&"
import script from "./InputOfReserveContactSituationReserveInfo.vue?vue&type=script&lang=ts&"
export * from "./InputOfReserveContactSituationReserveInfo.vue?vue&type=script&lang=ts&"
import style0 from "./InputOfReserveContactSituationReserveInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports